import React, { useEffect } from "react";
import Account from "../priya/Account";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

const AccountPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  useEffect(() => {
    if (!user) {
      localStorage.setItem("lastLoginPath","/account")
      navigate("/login");
    }
  }, [user]);
  return (
    <div className=" flex md:flex-row flex-col relative">
      <Account />
      <div className=" w-full">
        <Outlet />
      </div>
    </div>
  );
};

export default AccountPage;
